import Lottie, { LottieRefCurrentProps } from "lottie-react";
import { useEffect, useRef } from "react";
import LoadingJSON from "assets/lottie/loading.json";

interface ILoading {
    width?: number
}

const Loading = ({ width = 100 }: ILoading) => {
    const ref = useRef<LottieRefCurrentProps | null>(null);

    useEffect(() => {
        if (ref.current) {
            ref.current.setSpeed(0.7);
        }
    }, [])

    return (
        <div className={`w-[${width}px]`}>
            <Lottie
                lottieRef={ref}
                animationData={LoadingJSON}
                loop
                autoplay
            />
        </div>
    )
}

export default Loading